import React from "react";

import * as S from "./PriceDetailsTooltip.styles";

interface IPDToolTip {
  fare_details: Array<Idata>,
  apply_gocash: boolean,
  amount: number
};

interface Idata {
  Title: string;
  Subtitle: string;
  Value: string;
  Value_color: string;
}


const PriceDetailsTooltipUI: React.FC<IPDToolTip> = ({
  fare_details = [],
  apply_gocash = false,
  amount = 0
}) => {
  const gocashAmount = amount?.toString()?.includes('-') ? amount?.toString()?.split('-') : [amount];
  return (
    <S.PrcToolttip>
      {fare_details?.map(({ Title = '', Subtitle = '', Value = '', Value_color = '' }) => {
        const newValue = `${Value}`;
        const price = newValue.includes('-') ? newValue.split('-') : [newValue];
        const modifiedTitle = Title.includes('_dot_') ? Title.replace(/_dot_/g, ' • ') : Title;
        return (
          <div className="row">
            <S.PriceTip>
              <p className="font14 textDark">{modifiedTitle}</p>
              <p className="font12 textGray">{Subtitle}</p>
            </S.PriceTip>
            <div>
              <p className="fontMedium font16 textDark" style={{ color: Value_color, justifyContent: 'right', alignContent: 'right' }}>{price.length > 1 ? `- ₹${price[1]}` : `₹${Value}`}</p>
            </div>
          </div>
        )
      })}
    </S.PrcToolttip>
  );
};

export default React.memo(PriceDetailsTooltipUI);
